import { render, staticRenderFns } from "./MenuPublic.vue?vue&type=template&id=b0b572c6&"
import script from "./MenuPublic.vue?vue&type=script&lang=js&"
export * from "./MenuPublic.vue?vue&type=script&lang=js&"
import style0 from "./MenuPublic.vue?vue&type=style&index=0&id=b0b572c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports